import { t } from "../../i18n";
import { Link } from "react-router-dom";
import { useProjectStore } from "../../state/projectStore";
import { useAuth } from "../../auth/useAuth";

/** Üst çubukta kayıt/senkron durumu; bulut projede abonelik uyarısı. */
export function SyncStatus(): JSX.Element {
  const { origin, dirty, lastSavedAt, sync, syncError, readOnly } = useProjectStore();
  const sub = useAuth((s) => s.subscription);
  const saved = lastSavedAt ? new Date(lastSavedAt).toLocaleTimeString("tr-TR", { hour: "2-digit", minute: "2-digit" }) : null;
  let text: string; let tone = "text-stone";
  if (origin === "shared") { text = "Paylaşım görünümü · salt okunur"; }
  else if (origin === "local") { text = dirty ? "Kaydedilmemiş değişiklik" : saved ? `Taslak kaydedildi ${saved}` : ""; }
  else if (readOnly) { text = "Salt okunur"; tone = "text-bad"; }
  else if (sync === "conflict") { text = "Çakışma — çözüm bekliyor"; tone = "text-bad"; }
  else if (sync === "offline") { text = "Çevrimdışı — bağlanınca gönderilecek"; tone = "text-warn"; }
  else if (sync === "error") { text = `Kaydedilemedi: ${syncError ?? ""}`; tone = "text-bad"; }
  else if (sync === "saving") { text = "Buluta kaydediliyor…"; }
  else if (dirty) { text = "Değişiklik var"; }
  else { text = saved ? `Bulutta kaydedildi ${saved}` : "Bulut"; }
  return (
    <span className={`text-xs ${tone} flex items-center gap-2`} aria-live="polite" data-sync={sync} data-origin={origin}>
      {origin === "cloud" ? <span aria-hidden className="inline-block w-2 h-2 rounded-full bg-accent" title={t("Bulut projesi")} /> : null}
      {text}
      {origin === "cloud" && sub && !sub.canWrite ? <Link to="/planlar" className="underline text-bad">{t("Plan seç")}</Link> : null}
    </span>
  );
}
